import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payment__time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, [
      _createElementVNode("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M7.99998 14.4C9.69736 14.4 11.3252 13.7257 12.5255 12.5255C13.7257 11.3252 14.4 9.69736 14.4 7.99998C14.4 6.30259 13.7257 4.67473 12.5255 3.47449C11.3252 2.27426 9.69736 1.59998 7.99998 1.59998C6.30259 1.59998 4.67473 2.27426 3.47449 3.47449C2.27426 4.67473 1.59998 6.30259 1.59998 7.99998C1.59998 9.69736 2.27426 11.3252 3.47449 12.5255C4.67473 13.7257 6.30259 14.4 7.99998 14.4ZM8.59998 3.99998C8.59998 3.84085 8.53676 3.68823 8.42424 3.57571C8.31172 3.46319 8.15911 3.39998 7.99998 3.39998C7.84085 3.39998 7.68823 3.46319 7.57571 3.57571C7.46319 3.68823 7.39998 3.84085 7.39998 3.99998V7.99998C7.39998 8.33118 7.66878 8.59998 7.99998 8.59998H11.2C11.3591 8.59998 11.5117 8.53676 11.6242 8.42424C11.7368 8.31172 11.8 8.15911 11.8 7.99998C11.8 7.84085 11.7368 7.68823 11.6242 7.57571C11.5117 7.46319 11.3591 7.39998 11.2 7.39998H8.59998V3.99998Z",
        fill: "#F7F9FC"
      })
    ], -1)),
    _createElementVNode("span", null, _toDisplayString(_ctx.value), 1)
  ]))
}